export const AUTH_INIT = "AUTH_INIT";
export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

// POST INIT action is resetting the posts data
export const POST_INIT = "POST_INIT";
export const POST_START = "POST_START";
export const POST_SUCCESS = "POST_SUCCESS";
export const POST_FAIL = "POST_FAIL";
export const POST_TOGGLE_UPVOTE_SUCCESS = "POST_TOGGLE_UPVOTE";

export const POST_SUBMIT_INIT = "POST_SUBMIT_INIT";
export const POST_SUBMIT_START = "POST_SUBMIT_START";
export const POST_SUBMIT_SUCCESS = "POST_SUBMIT_SUCCESS";
export const POST_SUBMIT_FAIL = "POST_SUBMIT_FAIL";

export const POST_COMMENT_INIT = "POST_COMMENT_INIT";
export const POST_COMMENT_START = "POST_COMMENT_START";
export const POST_COMMENT_SUCCESS = "POST_COMMENT_SUCCESS";
export const POST_COMMENT_FAIL = "POST_COMMENT_FAIL";
export const POST_COMMENT_TOGGLE_UPVOTE_SUCCESS = "POST_COMMENT_TOGGLE_UPVOTE_SUCCESS";

export const POST_COMMENT_SUBMIT_START = "POST_COMMENT_SUBMIT_START";
export const POST_COMMENT_SUBMIT_SUCCESS = "POST_COMMENT_SUBMIT_SUCCESS";
export const POST_COMMENT_SUBMIT_FAIL = "POST_COMMENT_SUBMIT_FAIL";